import React, { useEffect, useState } from "react";
import * as Icons from "react-feather";
import { useCore } from "store/core";
import { Link } from "react-router-dom";
import Loading from "components/Loading";
import ListPagination from "components/list/ListPagination";
import ListSearch from "components/list/ListSearch";
import { useList } from "store/list";
import ManageAccessModal from "./ManageAccessModal";
import Edit from "./Edit";
import Delete from "./Delete";
import { handleSuccessMessages } from "store/auth";
import ResetPassword from "./ResetPassword";
import Add from "./Add";

export default function CatalogUsers() {
  const path = {
    baseRoute: "/panel/catalog-users",
    aliasName: "کاربران کاتالوگ",
    type: "CatalogUsers",
  };

  const {
    dispatch,
    clear,
    getList,
    list,
    load,
    create,
    update,
    quickUpdate,
    remove,
    listSearch,
    from,
    to,
    total,
  } = useList();
  const { getRoles, getCountries, getProductCategories } = useCore();

  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showAccessModal, setShowAccessModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [item, setItem] = useState(false);

  useEffect(() => {
    dispatch(getList(path));
    dispatch(getRoles());
    dispatch(getProductCategories());
    dispatch(getCountries());

    return () => {
      dispatch(clear());
    };
    // Store action creators are intentionally invoked only on mount/unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Add
        title="افزودن کاربر کاتالوگ"
        show={showAdd}
        close={() => {
          setShowAdd(false);
        }}
        submit={(values) => {
          dispatch(
            create(path, values, () => {
              handleSuccessMessages("کاربر کاتالوگ با موفقیت اضافه شد");
              dispatch(getList(path));
            }),
          );
        }}
      />

      <Edit
        item={item}
        title="ویرایش کاربر کاتالوگ"
        show={showEdit}
        close={() => {
          setShowEdit(false);
        }}
        submit={(values, id) => {
          dispatch(
            update(path, id, values, () => {
              handleSuccessMessages("کاربر کاتالوگ با موفقیت ویرایش شد");
              dispatch(getList(path));
            }),
          );
        }}
      />

      <Delete
        title="حذف کاربر کاتالوگ"
        show={showDelete}
        close={() => {
          setShowDelete(false);
        }}
        submite={() => {
          dispatch(
            remove(path, list, item.id, () => {
              handleSuccessMessages("کاربر کاتالوگ با موفقیت حذف شد");
              dispatch(getList(path));
              setShowDelete(false);
            }),
          );
        }}
      />

      <ResetPassword
        item={item}
        title="تغییر گذرواژه"
        show={showResetPassword}
        close={() => {
          setShowResetPassword(false);
        }}
        submite={(values, id) => {
          dispatch(
            quickUpdate(path, id, values, () => {
              handleSuccessMessages("گذرواژه تغییر یافت.");
              dispatch(getList(path));
            }),
          );
        }}
      />

      <ManageAccessModal
        show={showAccessModal}
        user={selectedUser}
        onClose={() => {
          setShowAccessModal(false);
          setSelectedUser(null);
        }}
        onSaved={() => {
          dispatch(getList(path));
        }}
      />

      <div className="content" style={{ marginBottom: 80 }}>
        <h2 className="intro-y text-lg font-medium mt-10">
          مدیریت کاربران کاتالوگ
        </h2>

        <div className="grid grid-cols-12 gap-6 mt-5">
          <div className="intro-y col-span-12 flex flex-wrap sm:flex-nowrap items-center mt-2">
            <button
              type="button"
              className="btn btn-primary shadow-md mr-2"
              onClick={() => setShowAdd(true)}
            >
              افزودن کاربر کاتالوگ
            </button>
            <Link
              to="/users/users"
              className="btn btn-outline-secondary shadow-md mr-2"
            >
              مدیریت همه کاربران
            </Link>

            {load && (
              <div className="hidden md:block mx-auto text-gray-600">
                در حال بارگذاری
              </div>
            )}

            {!load && (
              <div className="hidden md:block mx-auto text-gray-600">
                {`نمایش ${from} تا ${to} از ${total}`}
              </div>
            )}

            <ListSearch
              search={(key) => {
                dispatch(listSearch(path, key));
              }}
            />
          </div>

          <div className="intro-y col-span-12">
            <div className="alert alert-secondary show mb-2" role="alert">
              کاربر کاتالوگ از صفحه کاربران ساخته می‌شود و باید رول{" "}
              <b>catalog</b> داشته باشد. مدیریت دسترسی محصولات و دسته‌بندی‌ها از
              همین صفحه انجام می‌شود.
            </div>
          </div>

          <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
            <table className="table table-report -mt-2">
              <thead>
                <tr>
                  <th className="whitespace-nowrap text-center">شناسه</th>
                  <th className="whitespace-nowrap text-center">نام کاربری</th>
                  <th className="whitespace-nowrap text-center">
                    نام و نام خانوادگی
                  </th>
                  <th className="whitespace-nowrap text-center">وضعیت</th>
                  <th className="whitespace-nowrap text-center">
                    محصول مستقیم
                  </th>
                  <th className="whitespace-nowrap text-center">دسته بندی</th>
                  <th className="whitespace-nowrap text-center">دسترسی پلاس</th>
                  <th className="whitespace-nowrap text-center">تاریخ ایجاد</th>
                  <th className="whitespace-nowrap text-center">عملیات</th>
                </tr>
              </thead>

              {load && (
                <tbody>
                  <tr>
                    <td colSpan={9}>
                      <Loading />
                    </td>
                  </tr>
                </tbody>
              )}
              {list && !list.length > 0 && (
                <tbody>
                  <tr>
                    <td colSpan={9} className="text-center py-3">
                      چیزی یافت نشد
                    </td>
                  </tr>
                </tbody>
              )}

              <tbody>
                {!load &&
                  list &&
                  list.length > 0 &&
                  list.map((catalog) => (
                    <tr className="intro-x" key={catalog.id}>
                      <td className="w-16 text-center">{catalog.id}</td>
                      <td className="text-center">
                        {catalog.user_name || "-"}
                      </td>
                      <td className="text-center">
                        {catalog.full_name || "-"}
                      </td>
                      <td className="text-center">
                        {catalog.verified ? (
                          <span className="text-theme-9">تایید شده</span>
                        ) : (
                          <span className="text-theme-6">تایید نشده</span>
                        )}
                      </td>
                      <td className="text-center">
                        {catalog.direct_products_count || 0}
                      </td>
                      <td className="text-center">
                        {catalog.categories_count || 0}
                      </td>
                      <td className="text-center">
                        {catalog.all_plus_products ? (
                          <span className="text-theme-9">فعال</span>
                        ) : (
                          <span className="text-gray-500">غیرفعال</span>
                        )}
                      </td>
                      <td className="text-center">
                        {catalog.created_at || "-"}
                      </td>

                      <td className="table-report__action">
                        <div className="flex justify-center items-center">
                          <button
                            type="button"
                            className="flex items-center ml-3 cursor-pointer"
                            onClick={() => {
                              setItem(catalog);
                              setShowResetPassword(true);
                            }}
                          >
                            <Icons.Key className="w-4 h-4 ml-1" />
                            تغییر پسورد
                          </button>

                          <button
                            type="button"
                            className="flex items-center ml-3 cursor-pointer"
                            onClick={() => {
                              setItem(catalog);
                              setShowEdit(true);
                            }}
                          >
                            <Icons.CheckSquare className="w-4 h-4 ml-1" />{" "}
                            ویرایش
                          </button>

                          <button
                            type="button"
                            className="flex items-center text-theme-6 cursor-pointer"
                            onClick={() => {
                              setItem(catalog);
                              setShowDelete(true);
                            }}
                          >
                            <Icons.Trash2 className="w-4 h-4 ml-1" />
                            حذف
                          </button>
                        </div>
                        <div className="flex justify-center items-center">
                          <button
                            type="button"
                            className="flex items-center cursor-pointer"
                            onClick={() => {
                              setSelectedUser(catalog);
                              setShowAccessModal(true);
                            }}
                          >
                            <Icons.Settings className="w-4 h-4 ml-1" />
                            مدیریت دسترسی
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          <ListPagination
            getList={(page, perPage) => {
              dispatch(getList(path, page, perPage));
            }}
          />
        </div>
      </div>
    </>
  );
}
